<div class="c-card c-card--bg c-card--overlay u-osb-xxl" [ngStyle]="{ 'background-image': 'url(' + vm.img + ')' }">
	<div class="c-content c-content--on-top" style="height:330px">
		<div class="o-grid o-grid--fit">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--bottom" style="margin-bottom:-40px">
				<item-thumbnail size="lg"></item-thumbnail>
			</div>
			<div class="o-grid__cell u-no-pr">
				<div class="o-grid o-grid--fit o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right">
						<form class="c-form" name="vm.form">
							<div class="c-form__group u-no-m">
								<label for="{{ vm.uid }}" class="c-button c-button--s1 c-button--narrow u-ost-md" [ngClass]="{'c-button--disabled': vm.processing}">{{ 'Profile.Tooltip.Change_Cover_Pic' | translate }}</label>
								<input class="u-hidden" id="{{ vm.uid }}" name="{{ vm.uid }}" type="file" accept="image/*" (change)="onFileSelected($event)" [disabled]="vm.processing">
							</div>
						</form>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p o-grid__cell--bottom">
						<p class="c-text c-text--heading c-text--s11">{{ vm.title }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<loader-overlay style="z-index:1" *ngIf="vm.processing"></loader-overlay>
</div>
